import axios from 'axios';

const httpClient = axios.create();

httpClient.defaults.baseURL = process.env.REACT_APP_API_URL || null;

httpClient.interceptors.request.use(
  config => {
    return new Promise(resolve => {
      resolve(config);
    });
  },

  error => {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  response => {
    if (
      response &&
      response.hasOwnProperty('data') &&
      response.hasOwnProperty('config')
    ) {
      // console.log(response.config.url, response.data);
    }

    return response;
  },

  error => {
    return Promise.reject(error);
  }
);

export default httpClient;
